// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__tyDlo","header":"ReportDetails_header___SVCO","title":"ReportDetails_title__gkYFh","left":"ReportDetails_left__1fPhh"};